export default "__VITE_ASSET__BeTAbBQ$__"